var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.25,
    stroke: "#273943",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M13.75 14a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM15 11.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm12 7.5A5.25 5.25 0 0 0 21.75 24v6.25h2.5V24a2.75 2.75 0 1 1 5.5 0v6.25h2.5V24A5.25 5.25 0 0 0 27 18.75Zm0-1.5A6.75 6.75 0 0 0 20.25 24v7c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-7a1.25 1.25 0 0 1 2.5 0v7c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-7A6.75 6.75 0 0 0 27 17.25ZM12.25 19a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75V19Zm1.5.75v10.5h2.5v-10.5h-2.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin;